module.exports = __webpack_public_path__ + "img/IMG_1156_L_BlackMatted_MockedUp.c0ef94cb.jpg";